module.exports = __webpack_public_path__ + "img/IT0004916351812.18fd6b2d.png";